module.exports = __webpack_public_path__ + "kontron.png?c320c06927f7ae1d116abf388c8a12b8";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/trusted/kontron.png
// module id = 144
// module chunks = 0